// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tech-tile {
  margin: 0 12.5px;
}

.tech-tile__img {
  height: 150px;
  width: 150px;
  object-fit: contain;
}

.tech-tile__name {
  margin: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/elements/tech-tile/tech-tile.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".tech-tile {\n  margin: 0 12.5px;\n}\n\n.tech-tile__img {\n  height: 150px;\n  width: 150px;\n  object-fit: contain;\n}\n\n.tech-tile__name {\n  margin: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
